import React, { useEffect, useState } from 'react';
import reactStringReplace  from 'react-string-replace';
import { Button, Drawer } from '@nackle/origami';
import { LocaleString, getString } from '@nackle/intl-tools';
import { FetchPrivacyPolicy, GetAcknowledgement, PostAcknowledgement } from '../fetch-privacy-policy.js';
import { Close } from '@nackle/origami-icons';
import './cookie-notice.less';

const CookieNotice = ( {
    user,
    solutionId,
    contentLoaded
} ) => {

    const [ visible, setVisible ] = useState( false );

    useEffect( () => {
        async function fetchAcknowledgement() {
            if ( user && solutionId && contentLoaded ) {
                if ( user.access_token ) {
                    const result = await GetAcknowledgement( user.access_token, solutionId );
                    if ( !result.accepted ) {
                        setVisible( true );
                    }
                }
            }
        }

        fetchAcknowledgement();
    }, [ user, solutionId, contentLoaded ] );

    const handleClose = () => {
        PostAcknowledgement( user.access_token, solutionId );
        setVisible( false );
    };

    return <Drawer
        placement="bottom"
        closable={ false }
        maskClosable={ false }
        open={ visible }
        destroyOnClose={ true }
        onClose={ handleClose }>

        <div className="deck-cookie-notice">
            <div className="deck-cookie-notice-inner">
                <p className="deck-cookie-notice-content"> {
                    reactStringReplace( getString( 'deck.content.cookieNotice' ), '${privacyNoticeLink}', ( match, i ) => (
                        <a href={ FetchPrivacyPolicy( user?.claims?.company_id, solutionId, user?.claims?.locale ) } key={ i } className="deck-cookie-notice-link">
                            <LocaleString code="deck.link.privacyNotice" />
                        </a>
                    ) )
                }<br/>
                <Button type="primary" onClick={ handleClose } className="deck-cookie-notice-btn">
                    <LocaleString code="deck.link.acceptCookies" />
                </Button>
                </p>

            </div>
            <button className="nkl-deck-cookie-notice-close-btn" onClick={ handleClose }>
                <Close className="nkl-deck-cookie-notice-close-icon"/>
            </button>
        </div>
    </Drawer>;
};

export default CookieNotice;
